import { Modal, Table } from 'antd';
import React from 'react';

export default function Index(props) {
  const columns = [
    {
      title: '时间',
      dataIndex: 'create_time',
      key: 'create_time'
    },
    {
      title: '操作人',
      dataIndex: 'operate_name',
      key: 'operate_name'
    },
    {
      title: '公司名称',
      dataIndex: 'company',
      key: 'company',
      render: (text) => text.name
    },
    {
      title: '操作内容',
      dataIndex: 'log_analysis',
      key: 'log_analysis',
      render: (text) => text?.join()
    },
  ];
  const dataSource = props.data || [];
  return (
    <Modal title='操作日志' open footer={null} destroyOnClose={true} maskClosable={false} centered={true}  width={1000} onCancel={() => props.operationClose()}>
      <Table columns={columns} dataSource={dataSource} pagination={false} rowKey='id' scroll={{ y: 540, x:'max-content' }}/>
    </Modal>
  );
}
